import { httpClient } from '@/modules/common/services/http/http-client';
import {
  IFixedIncomeReponse,
  IProductsParams,
  IGovernmentBondReponse,
  IGovernmentBondParams,
  IFundsReponse,
  IProductDetails,
  ICustomOperationsResponse,
  IProductHero,
  IInitialPublicOfferingsResponse,
  ICategoryProductDetails,
  IProductPerformanceResponse,
  IProductCategoriesFiltersResponse,
  IProductAdditionalInfo
} from './products-types';

export const http = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}/instruments`
});

export const productsHttp = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}/products`
});

export function getFixedIncomeInstruments(
  filters: Record<string, string | string[]>,
  params: IProductsParams
): Promise<IFixedIncomeReponse> {
  return http.get(`/v1/catalog/bonds`, {
    params: { ...params, ...filters }
  });
}

export function getFixedIncomeProducts(
  filters: Record<string, string | string[]>,
  params: IProductsParams
): Promise<IFixedIncomeReponse> {
  return productsHttp.get(`/v1/catalog/bonds`, {
    params: { ...params, ...filters }
  });
}

export async function getGovernmentBondInstruments(
  params: IGovernmentBondParams
): Promise<IGovernmentBondReponse> {
  return await http.get(`/v1/catalog/government-bonds`, {
    params: { ...params }
  });
}

export async function getGovernmentBondProducts(
  params: IGovernmentBondParams
): Promise<IGovernmentBondReponse> {
  return await productsHttp.get(`/v1/catalog/government-bonds`, {
    params: { ...params }
  });
}

export async function getFundsInstruments(
  filters: Record<string, string | string[]>,
  params: IProductsParams
): Promise<IFundsReponse> {
  return await http.get(`/v1/catalog/funds`, {
    params: { ...params, ...filters }
  });
}

export async function getFundsProducts(
  filters: Record<string, string | string[]>,
  params: IProductsParams
): Promise<IFundsReponse> {
  return await productsHttp.get(`/v1/catalog/funds`, {
    params: { ...params, ...filters }
  });
}

export async function getCustomOperationsInstruments(
  params: IProductsParams
): Promise<ICustomOperationsResponse> {
  return await http.get(`/v1/catalog/custom-operations`, {
    params: { ...params }
  });
}

export async function getCustomOperationsProducts(
  params: IProductsParams
): Promise<ICustomOperationsResponse> {
  return await productsHttp.get(`/v1/catalog/custom-operations`, {
    params: { ...params }
  });
}

export function getProductDetails(
  apiId: string,
  instrumentType: string
): Promise<IProductDetails> {
  return http.get(`/v2/instrument/${apiId}/details`, {
    params: { instrumentType }
  });
}

export async function getProductHero(
  productApiId: string,
  category: string
): Promise<IProductHero> {
  return productsHttp.get(`/v3/categories/${category}/${productApiId}/hero`);
}

export function getCatalogProductDetails(
  productApiId: string,
  category: string,
  isBuilder: boolean,
  isAdding: boolean
): Promise<ICategoryProductDetails> {
  return productsHttp.get(`/v1/catalog/${category}/${productApiId}/details`, {
    params: { isBuilder, isAdding }
  });
}

export async function getInitialPublicOfferings(
  params: IProductsParams
): Promise<IInitialPublicOfferingsResponse> {
  return await productsHttp.get('/v1/catalog/initial-public-offerings', {
    params: { ...params }
  });
}

export async function getProductPerformancePrePurchase(
  productApiId: string,
  category: string,
  period: string,
  benchmark: string
): Promise<IProductPerformanceResponse> {
  return await productsHttp.get(
    `/v1/categories/${category}/${productApiId}/pre-purchase/performance`,
    {
      params: {
        period,
        benchmark
      }
    }
  );
}

export async function getProductCategoriesFilters(
  category: string
): Promise<IProductCategoriesFiltersResponse> {
  return await productsHttp.get(`/v2/categories/${category}/chart/filter`);
}

export async function getProductAdditionalInfo(): Promise<IProductAdditionalInfo> {
  return await productsHttp.get(`/v1/additional-info`);
}
